import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/logo.png';
var _hoisted_1 = { class: "home" };
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("img", {
    alt: "Vue logo",
    src: _imports_0
}, null, -1);
var _hoisted_3 = /*#__PURE__*/ _createTextVNode("按钮自动导入");
var _hoisted_4 = /*#__PURE__*/ _createTextVNode("组件按需导入");
var _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", null, "Pinia demo：", -1);
var _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", null, "组件 State demo", -1);
import { Button } from 'vant';
import { ref, toRefs } from 'vue';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import { useCount } from '@/stores/useCount';
// tips: pinia 解构丢失响应性，可使用 toRefs包裹后解构。
export default /*#__PURE__*/ _defineComponent({
    name: 'Home',
    setup: function (__props) {
        var _a = toRefs(useCount()), count = _a.count, countAdd = _a.countAdd;
        var counter = useCount();
        var test = ref(0);
        var title = ref('');
        var name = ref('');
        var addTest = function () {
            test.value++;
        };
        return function (_ctx, _cache) {
            var _component_van_button = _resolveComponent("van-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", null, [
                    _createVNode(_component_van_button, {
                        type: "success",
                        size: "mini"
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_3
                        ]; }),
                        _: 1
                    }),
                    _createVNode(_unref(Button), {
                        type: "primary",
                        size: "mini"
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_4
                        ]; }),
                        _: 1
                    })
                ]),
                _createElementVNode("div", null, [
                    _hoisted_5,
                    _createVNode(_unref(Button), {
                        type: "success",
                        size: "mini",
                        onClick: _unref(countAdd)
                    }, {
                        default: _withCtx(function () { return [
                            _createTextVNode("toRefs 解构 pinia ：count++ " + _toDisplayString(_unref(count)), 1)
                        ]; }),
                        _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(Button), {
                        type: "success",
                        size: "mini",
                        onClick: _unref(counter).countAdd
                    }, {
                        default: _withCtx(function () { return [
                            _createTextVNode("未解构 count++ " + _toDisplayString(_unref(counter).count), 1)
                        ]; }),
                        _: 1
                    }, 8, ["onClick"])
                ]),
                _createElementVNode("div", null, [
                    _hoisted_6,
                    _createVNode(_unref(Button), {
                        type: "primary",
                        size: "mini",
                        onClick: addTest
                    }, {
                        default: _withCtx(function () { return [
                            _createTextVNode("组件内部 state++ " + _toDisplayString(test.value), 1)
                        ]; }),
                        _: 1
                    })
                ]),
                _createVNode(HelloWorld, {
                    msg: "Hello Vue3!",
                    title: title.value,
                    "onUpdate:title": _cache[0] || (_cache[0] = function ($event) { return ((title).value = $event); }),
                    name: name.value,
                    "onUpdate:name": _cache[1] || (_cache[1] = function ($event) { return ((name).value = $event); })
                }, null, 8, ["title", "name"]),
                _createElementVNode("div", null, "父组件 v-model:title 示例：" + _toDisplayString(title.value), 1),
                _createElementVNode("div", null, "父组件 v-model:name 示例：" + _toDisplayString(name.value), 1)
            ]));
        };
    }
});
